import React from 'react'
import './Header.component.scss'
export default function Header() {
    return (
        <header className={"header"}>
            <div className="bar">
                <h1 className="logo">fram</h1>
            </div>
            <div className="content">
                <h1 className="label">
                    air taxi
                </h1>
                <h1>WELCOME TO FRAM -  YOUR PREMIER AIR TAXI SERVICE</h1>
                <p>
                    Our team specialize in short-haul, fast-response air taxi flights that go beyond the ordinary. We're not just another charter company; we're your trusted air taxi partner, committed to punctuality and convenience.Our team specialize in short-haul, fast-response air taxi flights that go beyond the ordinary. We're not just another charter company; we're your trusted air taxi partner, committed to punctuality and convenience.
                </p>
            </div>
        </header>
    )
}